import flatten from 'lodash/flatten';
import networkStatusService from '@/domain/services/generalPanel/networkStatus';

export const PANEL_PAGE_SIZE = 50;

/**
 * Ordenação enviada em todas as páginas.
 *
 * Precisa ser fixa: sem ordem estável no servidor, páginas buscadas em paralelo
 * podem repetir ou omitir instalações.
 */
const PANEL_SORT = { company: 'asc' };

function requestPage(filter, page) {
  return networkStatusService.getList({
    filter,
    page,
    pageSize: PANEL_PAGE_SIZE,
    sort: PANEL_SORT,
  });
}

/**
 * Carrega todas as páginas de status de rede como uma operação única.
 *
 * O ciclo é atômico por decisão de projeto: se qualquer página falhar, a promessa
 * é rejeitada e o painel mantém o último conjunto completo, deixando o relógio de
 * idade envelhecer. O painel nunca exibe uma frota parcial como se fosse inteira.
 *
 * @param {Object} [filter] Filtro de escopo do painel.
 * @returns {Promise<Object[]>} Todas as instalações do escopo.
 */
export default async function loadAllInstallations(filter) {
  const firstPage = await requestPage(filter, 1);
  const totalPages = firstPage.totalPages || 1;

  if (totalPages <= 1) {
    return firstPage.data || [];
  }

  const remainingPages = [];
  for (let page = 2; page <= totalPages; page += 1) {
    remainingPages.push(requestPage(filter, page));
  }

  const responses = await Promise.all(remainingPages);

  return (firstPage.data || []).concat(flatten(responses.map(response => response.data || [])));
}
